"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var env = "production" || "development";
exports.default = {
  // 超时时长
  DEFAULT_TIMEOUT_LIMIT: 5000,
  // 默认循环次数
  DEFAULT_INTERVAL_TIMES: 5,
  // iOS bridge name
  IOS_BRIDGE_NAME: "WebViewJavascriptBridge",
  // android bridge name
  ANDROID_BRIDGE_NAME: "AndroidMallBridge",
  // iOS bridge ready event
  IOS_BRIDGE_READY_EVENT: "WebViewJavascriptBridgeReady",
  // android bridge ready event
  ANDROID_BRIDGE_READY_EVENT: "AndroidMallBridgeReady",
  // ios WebViewJavascriptCallbacks
  IOS_BRIDGE_CALLBACKS: "WVJBCallbacks",
  // ios bridge loaded address
  IOS_BRIDGE_LOADED_ADDRESS: "wvjbscheme://__BRIDGE_LOADED__",
  //
  DEFAULT_CALLHANDLER_NAME: "MallBindJs",

  KAOP_MALL_HOST: env === "development" ? "http://dev-m-kaop.sdyxmall.com" : env === "production" ? "https://m-kaop.sdyxmall.com" : "https://pre-m-kaop.sdyxmall.com"
};